import type { FC } from "react";
import type { HoldReason } from "../../../../libs/mypage/logiless";
import type { OrderDetailDTO } from "../../components/format";
import { Notice } from "../../components/Notice";

/**
 * 確認待ち (発送保留) のうち、住所不備**以外**の注意喚起。住所不備は最上部の「ご対応のお願い」
 * (`ActionItemsSection`) が担当するのでここでは扱わない。
 *
 * Logiless の confirmation メッセージ自体は内部用なので顧客には出さず、「発送を一時保留している」
 * ことと、なぜ止めているかだけを端的に伝える。
 */
const BODY: Record<Exclude<HoldReason, "address">, string> = {
  cancel_request:
    "キャンセルのご依頼をいただいたため、発送を一時保留しております。担当者がお手続きのうえ、改めてご連絡いたします。",
  order_change:
    "ご注文内容の変更のご依頼をいただいたため、発送を一時保留しております。担当者が変更のうえ、改めてご連絡いたします。",
  auto_hold:
    "ご変更・キャンセル等のご連絡をいただいたため、発送を一時保留しております。担当者が確認のうえ、改めてご連絡いたします。",
  other: "確認のため、発送を一時保留しております。確認が取れ次第、発送いたします。",
};

export const OnHoldNotice: FC<{ order: OrderDetailDTO }> = ({ order }) => {
  if (order.holdReason === null || order.holdReason === "address") return null;

  return (
    <Notice variant="warn" title="発送を一時保留しています" className="mb-8">
      {BODY[order.holdReason]}
    </Notice>
  );
};
